import React, { useState } from 'react'
import styles from './styles'
import { Form, SuccessSvg, ErrorSvg } from '@xpertdox_js/xdcomponents'
import sendFeedback from './sendFeedback'
import { UserContext } from '../../Context/UserContext'
import TrialSearch from '../SearchTable/EmailBroadcast/UploadsSection/TrialSearch'
import TrialDisplay from './TrialDisplay'
import axios from 'axios'
import axiosConfig from '../../config/axios.config'
import { trackError } from '../../utils/activityTracker'
import { checkResponseErrorCodeAndRedirect } from '../../utils/errorHelper'

const FeedbackForm = props => {
  const { user } = React.useContext(UserContext)

  const [result, setResult] = useState(null)
  const [formInput, setFormInput] = useState({})
  const [trialSelection, setTrialSelection] = useState({})
  const [admins, setAdmins] = useState(null)
  const [adminError, setAdminError] = useState(false)

  if (!admins) {
    // removed 'axiosConfig.auth' as token is updated on login
    axios.get(`${axiosConfig.apiUrl}/rt/fetchAdmins/${user.instance}`).then(result => {
      if (result.data) {
        if (result.data.error) {
          console.log(result.data.error, 'ADMIN ERR')
          trackError({ error: result.data.error, history: props.history })
          setAdminError(true)
          setAdmins('error')
        } else setAdmins(result.data)
      }
    }).catch(err => {
      console.error(err);
      checkResponseErrorCodeAndRedirect(err);
    })
  }

  const addTrialToSelection = trial => {
    if (!trialSelection[trial._id]) {
      let update = {
        ...trialSelection,
        [trial._id]: trial
      }
      setTrialSelection(update)
    }
  }
  const removeTrialSelection = trial => {
    let update = { ...trialSelection }
    delete update[trial._id]
    setTrialSelection(update)
  }

  const settings = [
    {
      label: 'Choose a Trial Action',
      labelStyles: { paddingBottom: '32px' },
      type: 'select',
      options: [
        'Add Selected Trials',
        'Remove Selected Trials'
      ],
      id: 'trial_action'
    }
  ]

  const handleSubmit = async () => {
    let trialKeys = Object.keys(trialSelection)
    let trials = trialKeys.map(trial => ({ nct: trial, title: trialSelection[trial]._source.title1 }))
    const res = await sendFeedback({
      trials: trials,
      action: formInput.trial_action,
      user,
      admins
    }, 'adminFeedback')
    setResult(res)
  }

  const svgProps = {
    fontSize: '25px',
    width: '20%'
  }

  return (
    <div style={styles.container}>
      <div style={styles.formDescription}>
        <h2 style={styles.title}>Message Admin:</h2>
        {(admins && Array.isArray(admins)) && <div style={styles.admins.container}>
          {admins.map((a, i) => <div key={i} style={styles.admins.admin}>
            <h3 style={styles.admins.tag}>{a.name}</h3>
            <h3 style={styles.admins.tag}>{a.email}</h3>
          </div>)}
        </div>}
      </div>
      <div style={styles.formWrap}>
        {result === null || Object.values(trialSelection).length === 0
          ?
          <React.Fragment>
            <TrialSearch addTrial={addTrialToSelection} />
            {Object.keys(trialSelection).length > 0 &&
              <TrialDisplay removeTrial={removeTrialSelection} selection={Object.values(trialSelection)} />
            }
            <Form
              settings={settings}
              handleSubmit={handleSubmit}
              submitable={formInput.trial_action !== '' && Object.values(trialSelection).length > 0}
              state={{
                formState: formInput,
                setFormState: setFormInput
              }}
            />
          </React.Fragment>
          : result === true && Object.values(trialSelection).length > 0
            ? <SuccessSvg
              text={'Message Sent.'}
              {...svgProps}
            />
            : <ErrorSvg
              text={'Error Sending Message.'}
              {...svgProps}
            />
        }
      </div>
    </div>
  )
}

export default FeedbackForm
